import curd from '../curd'

const BASE_PATH = '/task/result/picture'

export default curd(BASE_PATH)



// WEBPACK FOOTER //
// ./src/apis/modules/TaskPicture.js